import React from 'react'
import { Input } from '../../Form'
import { getMessage } from '../../../lib/translator'
import searchIcon from '../icon-search.svg'
import crossIcon from '../../Form/cross_gray.svg'

const CouponTemplateFields = ({
  _this,
  taskIndex,
  awardIndex,
  dspTemplateCode,
  couponTitle,
  couponError,
  handleCouponSearch,
  handleCouponClear,
}) => (
  <div className="col-6">
    <Input
      name={`select-coupon-template-code-${awardIndex}`}
      label={getMessage('omnichallenge.task.couponTemplateCode')}
      placeholder={getMessage('omnichallenge.task.couponTemplateCode')}
      type="text"
      maxLength={50}
      value={dspTemplateCode}
      {..._this.generateStateMappers({
        stateKeys: [
          'taskList',
          taskIndex,
          'awardList',
          awardIndex,
          'dspTemplateCode',
        ],
      })}
      secondaryAction={{
        name: (
          <img
            key="coupon-search"
            src={searchIcon}
            alt={`select-coupon-template-code-${awardIndex}`}
          />
        ),
        onAction: (e) => {
          handleCouponSearch(e, awardIndex, dspTemplateCode)
        },
      }}
    />
    {couponError && <div className="error">{couponError}</div>}
    {couponTitle && (
      <div className="offer-select-value">
        <small>{couponTitle}</small>
        <button
          type="button"
          className="offer-select-value-icon"
          onClick={() => handleCouponClear(awardIndex)}
          aria-label={getMessage('rewards.catalogue.removeDspTemplateCode')}
        >
          <img src={crossIcon} alt="" />
        </button>
      </div>
    )}
  </div>
)

export default CouponTemplateFields
